import c from "../common";

export default {
    Name: "名稱",
    CollectedVsTotal: "已領取/總數",
    EventTime: "活動時間",
    Record: "記錄",
    Edit: "編輯",
    ConfirmCancel: "確定取消?",
    Yes: "是",
    No: "否",
    Cancel: "取消",
    EffectivePeriod: "使用期限",
    CollectAmount: "已領取數量",
    Left: "餘下",
    Probability: "機率(隨餘額改變)",
    QtyPerCollection: "每個電話可領取數量",
    Delete: "移除",
    NameCannotBeNull: "名稱不可為空",
    PleaseChooseCollectTime: "請選擇領取期限",
    SelectVoucher: "請選擇電子劵",
    QtyCannotBeZero: "用於禮遇計劃數量不可為0",
    QtyCannotBeNull: "請提供每次領取數量",
    PromoteCodeAreadyExist: "推廣碼已存在",
    ErrorOccured: "發生錯誤",
    CreatedSuccessfully: "成功創建",
    RewardEventNotFound: "禮遇計劃不存在",
    changeSuccessfully: "成功更改",
    RewardEvent: "禮遇計劃",
    Create: "創建",
    Confirm: c.Confirm.chn,
    Submit: "提交",
    Voucher: c.voucher.chn,
    OnGoing: c.OnGoing.chn,
    Pending: c.Pending.chn,
    Expired: c.Expired.chn,
    Cancelled: c.Cancelled.chn,
    Regulation1: "規則: 於領取期限內, 每個電話限領取一次, 隨機送出一份禮物",
    GiftContent: "禮包",
    CollectPeriod: "領取期限:",
    To: "至",
    VoucherName: "電子劵名稱",
    Value: "價值: $",
    NoSuchVoucher: "沒有可選電子劵",
    UpperBound: "上限:",
    LowerBound: "下限:",
    MustBeInteger: "必須整數",
    ExceedUpperOrLower: "超出上下限",
    Translation1: "領取記錄",
    PromoteCode: "推廣碼",
    PromoteCodeCannotBeNull: "推廣碼不可為空",
    PromoteCodeLengthMustBe6: "推廣碼長度須為6",
    PromoteCodeContent: "推廣碼僅可包含字母和數字",
    WhenEventNotYetStart: "當活動尚未進行時, 可以更改以下內容",
    BriefIntro: "簡介",
    Optional: "選填",
    PromoteCodeTranslation1: "推廣碼 (長度為6, 只可包含英文大階或數字)",
    SelectThatVoucher: "選擇劵",
    ReChoose: "重選",
    edit: "修改",
    availQty: "可用數量",
    Collected: "已領取",
    Rule: "活動規則",
    RuleDescription1: "每個電話限領取一次",
    RuleDescription2: "每次領取",
    RuleDescription3: "張指定電子劵",
    JoinedShop: "已參與商戶",
    None: "暫無",
    Voucher: c.voucher.chn,
    RewardEventName: "禮遇計劃名稱",
    Reward: "禮遇",
    //
    text1: "贈送積分數量最小為1",
    text2: "必須選擇送積分或電子劵",
    text3: "修改此資料將重新填寫表格",
    text4: "贈送積分",
    text5: "是",
    text6: "否",
    text7: "如要贈送積分, 須有在賺取積分期內的積分計劃",
    text8: "前往創建",
    text9: "贈送積分數量",
    text10: "賺分期限",
    text11: "增加劵",
    text12: "推廣碼到期: {{end}}",
    text13: "只顯示 {{end}} 或之後到期的電子劵",
    text14: "分",
    text15: "餘下",
    text16: "名稱/使用期限",
    text17: "禮包不可為空",

};
